import React from "react";
import "./quickviewProductDetails.css";
import SizeButtons from "./SizeButtons";

const ProductPrimaryDetails = ({ productDetailsData }) => {
  return (
    <div className="quick-view-productdetails py-3">
      <h5 className="quick-view-category-name">
        {productDetailsData?.brand_name}
      </h5>
      <h3 className="quick-view-product-name">
        {productDetailsData?.product_name}
      </h3>
      <div className="d-flex gap-3">
        <div className="quick-view-product-price">
          Rs.{productDetailsData?.original_price}
        </div>
        {productDetailsData?.discount_price !== 0 && (
          <div className="quick-view-product-price text-decoration-line-through">
            Rs.{productDetailsData?.discount_price}
          </div>
        )}
      </div>

      <p
        className="para-text"
        dangerouslySetInnerHTML={{
          __html: productDetailsData?.description || "",
        }}
      >
        
      </p>
    </div>
  );
};

export default ProductPrimaryDetails;
